import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

import { LRS_ACTIONS, TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP } from '@techchange/components';

const propTypes = {

	/**
	 * The video ID (if any).
	 */
	id: PropTypes.string,

	/**
	 * The video URL.
	 */
	src: PropTypes.string.isRequired,

	/**
	 * The aspect ratio for the video.
	 */
	aspectRatio: PropTypes.string,

	/**
	 * Flag to auto play the video.
	 */
	autoplay: PropTypes.bool,

	/**
	 * Callback function to handle video watching.
	 */
	onVideoWatch: PropTypes.func,

};

const defaultProps = {
	aspectRatio: TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP,
	autoplay: false,
};

const NativeVideoPlayer = (props) => {

	const { id, src, aspectRatio, autoplay, onVideoWatch } = props;

	const ref = useRef(null);

	const handleEvent = (status) => {

		let currentTime;

		let totalTime;

		if (ref && ref.current) {

			currentTime = ref.current.getCurrentTime();
			totalTime = ref.current.getDuration();

		}

		if (status && id && onVideoWatch) {

			const metadata = {
				id,
				status,
				currentTime,
				totalTime,
			};

			onVideoWatch(metadata);

		}

	};

	return (
		<div
			className={`tc-native-vimeo-player-embed ratio ratio-${aspectRatio}`}>
			<ReactPlayer
				ref={ref}
				className="tc-native-video-player"
				config={{
					file: {
						// React DOM prop name — `autoplay` is dropped with an
						// "Invalid DOM property" warning and never applies.
						attributes: { autoPlay: autoplay },
					}
				}}
				url={src}
				width="100%"
				height="100%"
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
				}}
				controls // Display native player controls
				onPlay={() => handleEvent(LRS_ACTIONS.PLAYED)}
				onPause={() => handleEvent(LRS_ACTIONS.PAUSED)}
				onEnded={() => handleEvent(LRS_ACTIONS.FINISHED)} />
		</div>
	);

};

NativeVideoPlayer.propTypes = propTypes;
NativeVideoPlayer.defaultProps = defaultProps;

export default NativeVideoPlayer;
